import { render } from "./editProcessTransportModal.vue?vue&type=template&id=05b5f8aa&scoped=true&ts=true"
import script from "./editProcessTransportModal.vue?vue&type=script&lang=ts"
export * from "./editProcessTransportModal.vue?vue&type=script&lang=ts"

import "./editProcessTransportModal.vue?vue&type=style&index=0&id=05b5f8aa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b5f8aa"]])

export default __exports__